// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"2cd48a6e","408":"60ac2ba8"}[chunkId] + ".chunk.js";
};